export default __webpack_public_path__ + "static/media/lightdarkthemes_mobile.48ef868b.png";